{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2020 - 2024                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDirections.TomTom;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

procedure RegisterTomTomDirectionsService;
procedure UnRegisterTomTomDirectionsService;

implementation

uses
  Classes, Math, DateUtils, Types, SysUtils, WEBLib.TMSFNCDirections,
  WEBLib.TMSFNCUtils, WEBLib.TMSFNCTypes, WEBLib.TMSFNCMapsCommonTypes, WEBLib.TMSFNCCloudBase
  {$IFNDEF WEBLIB}
  {$IFNDEF LCLLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION > 26}
  ,JSON
  {$ELSE}
  ,DBXJSON
  {$IFEND}
  {$HINTS ON}
  {$ELSE}
  ,fpjson
  {$ENDIF}
  {$ENDIF}

  {$IFDEF WEBLIB}
  ,Contnrs, Web, WEBLIB.JSON
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  ,Generics.Collections, Generics.Defaults
  {$HINTS OFF}
  {$IF COMPILERVERSION > 22}
  , UITypes
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

type
  TTMSFNCDirectionsTomTomService = class;

  TTMSFNCDirectionsTomTomDirectionsFactoryService = class(TTMSFNCDirectionsFactoryService, ITMSFNCDirectionsServiceTomTom);

  TTMSFNCDirectionsTomTomService = class(TTMSFNCDirectionsTomTomDirectionsFactoryService)
  protected
    function DoCreateDirections: ITMSFNCCustomDirections; override;
  end;

type
  TTMSFNCDirectionsTomTomDirections = class;

  TTMSFNCDirectionsTomTomDirections = class(TTMSFNCCustomDirectionsInterfacedObject, ITMSFNCCustomDirections)
  protected
    FTravelMode: TTMSFNCDirectionsTravelMode;
    function GetIdentifier: string;
    function IsValid: Boolean;
    function GetRequestMethod: TTMSFNCCloudBaseRequestMethod;
    function GetHost: string;
    function GetPath(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
      ADestinationLatitude, ADestinationLongitude: Double; ATravelMode: TTMSFNCDirectionsTravelMode; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil): string;
    function GetQuery(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
      ADestinationLatitude, ADestinationLongitude: Double; AAlternatives: Boolean = False;
      ATravelMode: TTMSFNCDirectionsTravelMode = tmDriving; AWayPointList: TStringList = nil; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil;
      AOptimizeWayPoints: Boolean = False; ALocale: string = ''; AAVoidTolls: Boolean = False;
      AAvoidHighways: Boolean = False): string;
    function GetPostData(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
      ADestinationLatitude, ADestinationLongitude: Double; AAlternatives: Boolean = False;
      ATravelMode: TTMSFNCDirectionsTravelMode = tmDriving; AWayPointList: TStringList = nil; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil;
      AOptimizeWayPoints: Boolean = False; ALocale: string = ''; AAvoidTolls: Boolean = False;
      AAvoidHighways: Boolean = False): string;
    procedure Parse(ARequest: TTMSFNCDirectionsRequest; ARequestResult: string);
    procedure AddHeaders(AHeaders: TTMSFNCCloudBaseRequestHeaders);
    procedure DestroyDirections;
  public
    constructor Create;
    destructor Destroy; override;
  end;

var
  DirectionsService: ITMSFNCDirectionsServiceTomTom;

procedure RegisterTomTomDirectionsService;
begin
  if not TTMSFNCDirectionsPlatformServices.Current.SupportsPlatformService(ITMSFNCDirectionsServiceTomTom, IInterface(DirectionsService)) then
  begin
    DirectionsService := TTMSFNCDirectionsTomTomService.Create;
    TTMSFNCDirectionsPlatformServices.Current.AddPlatformService(ITMSFNCDirectionsServiceTomTom, DirectionsService);
  end;
end;

procedure UnregisterTomTomDirectionsService;
begin
  TTMSFNCDirectionsPlatformServices.Current.RemovePlatformService(ITMSFNCDirectionsServiceTomTom);
end;

{ TTMSFNCDirectionsTomTomService }

function TTMSFNCDirectionsTomTomService.DoCreateDirections: ITMSFNCCustomDirections;
begin
  Result := TTMSFNCDirectionsTomTomDirections.Create;
end;

procedure TTMSFNCDirectionsTomTomDirections.AddHeaders(
  AHeaders: TTMSFNCCloudBaseRequestHeaders);
begin

end;

constructor TTMSFNCDirectionsTomTomDirections.Create;
begin
  inherited;
end;

destructor TTMSFNCDirectionsTomTomDirections.Destroy;
begin
  inherited;
end;

procedure TTMSFNCDirectionsTomTomDirections.DestroyDirections;
begin
  DirectionsService.DestroyDirections(Self);
end;

function TTMSFNCDirectionsTomTomDirections.GetHost: string;
begin
  Result := 'https://api.tomtom.com';
end;

function TTMSFNCDirectionsTomTomDirections.GetIdentifier: string;
begin
  Result := 'TomTom';
end;

function TTMSFNCDirectionsTomTomDirections.GetPath(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
  ADestinationLatitude, ADestinationLongitude: Double; ATravelMode: TTMSFNCDirectionsTravelMode; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil): string;
var
  WayPoints: string;
  I: Integer;
begin
  AOrigin := TTMSFNCUtils.FloatToStrDot(AOriginLatitude) + ',' + TTMSFNCUtils.FloatToStrDot(AOriginLongitude);
  ADestination := TTMSFNCUtils.FloatToStrDot(ADestinationLatitude) + ',' + TTMSFNCUtils.FloatToStrDot(ADestinationLongitude);

  AOrigin := TTMSFNCUtils.FloatToStrDot(AOriginLatitude) + ',' + TTMSFNCUtils.FloatToStrDot(AOriginLongitude);
  ADestination := TTMSFNCUtils.FloatToStrDot(ADestinationLatitude) + ',' + TTMSFNCUtils.FloatToStrDot(ADestinationLongitude);

  WayPoints := AOrigin;
  if Assigned(AWaypoints) and (Length(AWayPoints) > 0) then
  begin
    for I := 0 to (Length(AWayPoints) - 1) do
      WayPoints := WayPoints + ':' + TTMSFNCUtils.FloatToStrDot(AWayPoints[I].Latitude) + ',' + TTMSFNCUtils.FloatToStrDot(AWayPoints[I].Longitude);
  end;
  WayPoints := WayPoints + ':' + ADestination;

  Result := '/routing/1/calculateRoute/' + WayPoints + '/json';
end;

function TTMSFNCDirectionsTomTomDirections.GetPostData(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
      ADestinationLatitude, ADestinationLongitude: Double; AAlternatives: Boolean = False;
      ATravelMode: TTMSFNCDirectionsTravelMode = tmDriving; AWayPointList: TStringList = nil; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil;
      AOptimizeWayPoints: Boolean = False; ALocale: string = ''; AAvoidTolls: Boolean = False;
      AAvoidHighways: Boolean = False): string;
begin
  Result := '';
end;

function TTMSFNCDirectionsTomTomDirections.GetQuery(AOrigin, ADestination: string; AOriginLatitude, AOriginLongitude,
      ADestinationLatitude, ADestinationLongitude: Double; AAlternatives: Boolean = False;
  ATravelMode: TTMSFNCDirectionsTravelMode = tmDriving; AWayPointList: TStringList = nil; AWayPoints: TTMSFNCMapsCoordinateRecArray = nil;
  AOptimizeWayPoints: Boolean = False; ALocale: string = ''; AAVoidTolls: Boolean = False;
      AAvoidHighways: Boolean = False): string;
var
  TravelMode, Alternatives: string;
begin
  if AAlternatives then
    Alternatives := '5'
  else
    Alternatives := '0';

  if ATravelMode in [tmPublicTransport] then
    FTravelMode := tmDriving
  else
    FTravelMode := ATravelMode;

  case ATravelMode of
    tmDriving: TravelMode := 'car';
    tmWalking: TravelMode := 'pedestrian';
    tmBicycling: TravelMode := 'bicycle';
    tmTruck: TravelMode := 'truck';
  end;

  Result := 'key=' + DirectionsProperties.GetAPIKey
  + '&maxAlternatives=' + Alternatives
  + '&computeBestOrder=' + BoolToStrEx(AOptimizeWayPoints)
  + '&instructionsType=text'
  + '&travelMode=' + TravelMode
  + '&language=' + ALocale;

  if AAVoidTolls then
    Result := Result + '&avoid=tolls';

  if AAVoidHighways then
    Result := Result + '&avoid=motorways';
end;

function TTMSFNCDirectionsTomTomDirections.GetRequestMethod: TTMSFNCCloudBaseRequestMethod;
begin
  Result := rmGet;
end;

function TTMSFNCDirectionsTomTomDirections.IsValid: Boolean;
begin
  Result := DirectionsProperties.GetAPIKey <> '';
end;

procedure TTMSFNCDirectionsTomTomDirections.Parse(ARequest: TTMSFNCDirectionsRequest; ARequestResult: string);
var
  d: TTMSFNCDirectionsItems;
  di: TTMSFNCDirectionsItem;
  co: TTMSFNCMapsCoordinateItem;
  l: TTMSFNCDirectionsLeg;
  step: TTMSFNCDirectionsStep;
  wp: TTMSFNCDirectionsWayPoint;

  o, jo, jol, jos: TJSONValue;
  jar, jal, jas: TJSONArray;
  i, j, k: Integer;
  ol, os: TJSONObject;
  wpIndex: array of integer;
  providedIndex, optimizedIndex: integer;
begin
  if Assigned(DirectionsProperties) then
  begin
    ARequest.TravelMode := FTravelMode;

    d := ARequest.Items;
    if Assigned(d) then
    begin
      if ARequestResult <> '' then
      begin
        o := TTMSFNCUtils.ParseJSON(ARequestResult);
        if Assigned(o) then
        begin
          try
            ARequest.Status := TTMSFNCUtils.GetJSONProp(o, 'httpStatusCode');
            ARequest.ErrorMessage := TTMSFNCUtils.GetJSONProp(o, 'errorText');

            SetLength(wpIndex, 1);
            wpIndex[0] := -1;

            jal := TTMSFNCUtils.GetJSONValue(o, 'optimizedWaypoints') as TJSONArray;
            if Assigned(jal) then
            begin
              SetLength(wpIndex, TTMSFNCUtils.GetJSONArraySize(jal) + 1);

              for j := 0 to TTMSFNCUtils.GetJSONArraySize(jal) - 1 do
              begin
                jol := TTMSFNCUtils.GetJSONArrayItem(jal, j);

                if Assigned(jol) then
                begin
                  providedIndex := TTMSFNCUtils.GetJSONIntegerValue(jol, 'providedIndex');
                  optimizedIndex := TTMSFNCUtils.GetJSONIntegerValue(jol, 'optimizedIndex');
                  wpIndex[providedIndex + 1] := optimizedIndex;
                end;
              end;
            end;

            jar := TTMSFNCUtils.GetJSONValue(o, 'routes') as TJSONArray;
            if Assigned(jar) then
            begin
              for i := 0 to TTMSFNCUtils.GetJSONArraySize(jar) - 1 do
              begin
                jo := TTMSFNCUtils.GetJSONArrayItem(jar, i);

                di := d.Add;
                di.Summary := 'Route ' + IntToStr(i);

                jal := TTMSFNCUtils.GetJSONValue(jo, 'legs') as TJSONArray;
                if Assigned(jal) then
                begin
                  for j := 0 to TTMSFNCUtils.GetJSONArraySize(jal) - 1 do
                  begin
                    jol := TTMSFNCUtils.GetJSONArrayItem(jal, j);

                    l := di.Legs.Add;

                    wp := di.WayPoints.Add;
                    if Length(wpIndex) > j then
                      wp.OptimizedIndex := wpIndex[j];

                    ol := TTMSFNCUtils.GetJSONValue(jol, 'summary') as TJSONObject;
                    if Assigned(ol) then
                    begin
                      l.Distance := TTMSFNCUtils.GetJSONIntegerValue(ol, 'lengthInMeters');
                      di.Distance := di.Distance + l.Distance;
                      l.Duration := TTMSFNCUtils.GetJSONIntegerValue(ol, 'travelTimeInSeconds');
                      di.Duration := di.Duration + l.Duration;
                      wp.Distance := l.Distance;
                      wp.Duration := l.Duration;
                    end;

                    jas := TTMSFNCUtils.GetJSONValue(jol, 'points') as TJSONArray;
                    if Assigned(jas) then
                    begin
                      for k := 0 to TTMSFNCUtils.GetJSONArraySize(jas) - 1 do
                      begin
                        jos := TTMSFNCUtils.GetJSONArrayItem(jas, k);

                        co := di.Coordinates.Add;
                        co.Latitude := TTMSFNCUtils.GetJSONDoubleValue(jos, 'latitude');
                        co.Longitude := TTMSFNCUtils.GetJSONDoubleValue(jos, 'longitude');
                        l.Coordinates.Add.Assign(co);
                      end;
                    end;

                    if l.Coordinates.Count > 0 then
                    begin
                      l.StartLocation.Assign(l.Coordinates[0].Coordinate);
                      l.EndLocation.Assign(l.Coordinates[l.Coordinates.Count - 1].Coordinate);
                    end;

                  end;
                end;

                ol := TTMSFNCUtils.GetJSONValue(jo, 'guidance') as TJSONObject;
                if Assigned(ol) then
                begin
                  jas := TTMSFNCUtils.GetJSONValue(ol, 'instructions') as TJSONArray;
                  if Assigned(jas) then
                  begin
                    for k := 0 to TTMSFNCUtils.GetJSONArraySize(jas) - 1 do
                    begin
                      jos := TTMSFNCUtils.GetJSONArrayItem(jas, k);

                      step := di.Steps.Add;
                      step.Distance := TTMSFNCUtils.GetJSONIntegerValue(jos, 'routeOffsetInMeters');
                      step.Duration := TTMSFNCUtils.GetJSONIntegerValue(jos, 'travelTimeInSeconds');
                      os := TTMSFNCUtils.GetJSONValue(jos, 'point') as TJSONObject;
                      if Assigned(os) then
                      begin
                        step.StartLocation.Latitude := TTMSFNCUtils.GetJSONDoubleValue(os, 'latitude');
                        step.StartLocation.Longitude := TTMSFNCUtils.GetJSONDoubleValue(os, 'longitude');
                      end;
                      step.Instructions := TTMSFNCUtils.GetJSONProp(jos, 'message');
                    end;
                  end;
                end;

              end;
            end;
          finally
            o.Free;
          end;
        end
        else
        begin
          //error
          ARequest.Status := ARequestResult;
          ARequest.ErrorMessage := ARequest.Status;
        end;
      end;
    end;
  end;
end;

end.

